<div
  class="em-c-hero supplier-api-home hero-background"
  style="background-image: url(../assets/images/hero-block.jpg)"
>
  <div class="em-c-hero__body">
    <unity-container>
      <h1 class="em-c-hero__title title-text">Chemical IT - Entitlement</h1>
      <p class="em-c-hero__desc">
        Welcome, {{ (storeService.user$ | async)?.name }}
      </p>
    </unity-container>
  </div>
</div>

<unity-container class="section">
  <unity-grid variant="2-up">
    <div unity-grid-item class="home-page-icon-container">
      <img
        src="assets/images/entitlement-icon.png"
        class="home-page-icon"
        style="width: 200px; height: 200px"
      />
    </div>
    <div unity-grid-item class="home-page-desc-container">
      <h2 class="item-title">Entitlement</h2>
      <p class="item-detail">
        Access rights or privilege that define how clients can access
        ExxonMobil’s data through API, categorized by API services. User can add
        a new client imported from Identity Provider or add a new entitlement to
        the existing client here.
      </p>
      <button
        unity-button
        variant="primary"
        class="cta-button"
        routerLink="service"
      >
        Maintain
      </button>
    </div>
  </unity-grid>
</unity-container>

<div class="alt-section">
  <unity-container class="section">
    <unity-grid variant="2-up">
      <div unity-grid-item class="home-page-desc-container">
        <h2 class="item-title">Client</h2>
        <p class="item-detail">
          List of clients entitled for ExxonMobil’s API and their registered
          services. Easily view the entitlement by browsing through the list.
        </p>
        <button
          unity-button
          variant="primary"
          class="cta-button"
          routerLink="client"
        >
          Explore
        </button>
      </div>
      <div unity-grid-item class="home-page-icon-container">
        <img
          src="assets/images/client-icon.png"
          class="home-page-icon"
          style="width: 200px; height: 200px"
        />
      </div>
    </unity-grid>
  </unity-container>
</div>

<unity-container class="section">
  <unity-grid variant="2-up">
    <div unity-grid-item class="home-page-icon-container">
      <img
        src="assets/images/coding-icon.png"
        class="home-page-icon"
        style="width: 200px; height: 200px"
      />
    </div>
    <div unity-grid-item class="home-page-desc-container">
      <h2 class="item-title">Developer tool</h2>
      <p class="item-detail">
        Explore list of APIs associate with the entitlement. Securely and
        quickly connect to our entitlement from anytime, anywhere.
      </p>
      <button
        unity-button
        variant="primary"
        class="cta-button"
        routerLink="document/api-document"
      >
        API Spec
      </button>
    </div>
  </unity-grid>
</unity-container>
